import React from "react";
import { useDarkMode } from "../ThemeContext";

export default function ThemeSelector() {
  const [, , theme, setTheme] = useDarkMode();

  return (
    <fieldset className="theme-selector">
      <legend>Theme</legend>
      <div className="theme-options">
        <label className="theme-option">
          <input
            type="radio"
            name="site-theme"
            value="cream"
            checked={theme === "cream"}
            onChange={() => setTheme("cream")}
          />
          Light
        </label>
        <label className="theme-option">
          <input
            type="radio"
            name="site-theme"
            value="dark"
            checked={theme === "dark"}
            onChange={() => setTheme("dark")}
          />
          Dark
        </label>
        <label className="theme-option">
          <input
            type="radio"
            name="site-theme"
            value="light"
            checked={theme === "light"}
            onChange={() => setTheme("light")}
          />
          Purple
        </label>
      </div>
    </fieldset>
  );
}
